module.exports = __webpack_public_path__ + "static/media/pm.8ae21985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/pm.png
// module id = 1296
// module chunks = 110